









import {Component, Prop, Vue} from 'vue-property-decorator'
import Dropdown from './Dropdown.vue'

@Component
export default class DropdownOption extends Vue {
  public isSelected: boolean = false;

  clicked () {
    const parent = this.$parent as Dropdown
    parent.select(this.value)
  }

  @Prop({required: false, default: null})
  public readonly value!: any
}

